import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';

function NotFound() {
  return (
    <div className="NotFound">
      <Container fluid="md" className="d-flex flex-column justify-content-evenly align-items-center vh-100">
        <Row className="text-center">
          <p className="h3 text-light">404: not found</p>
        </Row>
        <Row className="text-center">
          <Link to="/"><Button variant="light" size="lg">Back</Button></Link>
        </Row>
      </Container>
    </div>
  );
}

export default NotFound;